import {
  useCustomAlertStore,
  usePathStore,
} from "../../../../Store/store";
import {
  PotreeGenerateAreaStore,
  usePotreeStore,
  usePathModeStore,
  useLastAreaMeasurementStore,
  useHeadlandWorkAreaStore,
} from "../../../../Store/PotreeStore";
import {
  handleEquipmentPathReset,
  clearPotreeProfiles,
} from "../../PathRemove_Create";
import { clearRhombusMarkers } from "../../../../util/sceneObjects";

/**
 * 경로 초기화, 전체 초기화(reload), 고도 컬러맵, 영역 제거
 * Pathgenerate reset 관련 로직만 분리
 */
export function usePathReset() {
  const { showWarningAlert } = useCustomAlertStore();
  const {
    viewer,
    setPathGenerateMode,
    setPathEditMode,
    resetEquipmentPath,
    selectedEquipmentId,
  } = usePathStore();
  const { gradientCover, setIsStartAreaGenerate, setIsPathGenerated } =
    PotreeGenerateAreaStore();
  const { potreeViewer } = usePotreeStore();
  const { setFullPathStore, setBezierCurves } = usePathModeStore();
  const { clearLastAreaMeasurement } = useLastAreaMeasurementStore();
  const { clearHeadlandWorkArea } = useHeadlandWorkAreaStore();

  const handlePathReset = () => {
    showWarningAlert(
      "경로 초기화",
      "경로 및 장애물을 초기화하시겠습니까?",
      () => {
        handleEquipmentPathReset(
          viewer,
          setPathGenerateMode,
          setPathEditMode,
          resetEquipmentPath,
          selectedEquipmentId,
        );
      },
    );
    // 씬 내 오브젝트 개수 확인
  };

  /**
   * "가장 단순한 전체 초기화" 버튼:
   * - 페이지를 새로고침하여 PotreeViewer/PointCloud 로딩부터 다시 시작합니다.
   * - 화면에 렌더링된 모든 요소(경로/측정/프로파일/컬러맵/애니메이션 등)가 함께 초기화됩니다.
   */
  const handleHardReset = () => {
    showWarningAlert(
      "포인트클라우드 재로딩(전체 초기화)",
      "페이지를 새로고침하여 포인트클라우드 로딩부터 다시 시작합니다. 진행할까요?",
      () => window.location.reload(),
    );
  };

  const handleGradientCover = () => {
    gradientCover && gradientCover();
  };

  /**
   * 영역 제거 — 경로 관련 씬 오브젝트 + 스토어 상태를 전부 초기화하여
   * 포인트 클라우드 지형은 유지한 채 다시 영역 지정이 가능하도록 한다.
   */
  const handleAreaRemove = () => {
    showWarningAlert(
      "영역 제거",
      "생성된 경로 및 영역을 모두 제거하시겠습니까?\n포인트 클라우드 지형은 유지됩니다.",
      () => {
        // 1. Potree 프로파일 + 측정 영역 제거
        clearPotreeProfiles(potreeViewer);

        // 2. 씬에서 named 그룹/오브젝트 제거
        const scene = potreeViewer?.scene?.scene;
        if (scene) {
          const namedObjects = [
            "full_path_group",
            "swaths",
            "headland_area",
            "bezier-controls",
            "start_point",
            "tractor",
          ];
          namedObjects.forEach((name) => {
            const obj = scene.getObjectByName(name);
            if (obj) {
              obj.traverse?.((child) => {
                child.geometry?.dispose?.();
                child.material?.dispose?.();
              });
              scene.remove(obj);
            }
          });

          // 3. 파종 마커 제거
          clearRhombusMarkers(scene);
        }

        // 4. 스토어 초기화
        setIsPathGenerated(false);
        setFullPathStore(null);
        setBezierCurves([]);
        clearLastAreaMeasurement();
        clearHeadlandWorkArea();
        setIsStartAreaGenerate(false);
      },
    );
  };

  return {
    handlePathReset,
    handleHardReset,
    handleGradientCover,
    handleAreaRemove,
  };
}
